module.exports = __webpack_public_path__ + "da9f856462327799633d4c48ed3458a9.pdf";